import { atom } from 'jotai';

import { ICrumbAdditionalData } from './ticketTrail.atoms';

export enum PolicyType {
    PRE_FILTER = 'PRE_FILTER',
    PRE_PROCESS = 'PRE_PROCESS',
    AUTO_TAG = 'AUTO_TAG',
    QUEUE_FILTER = 'QUEUE_FILTER',
    FRESHNESS_FILTER = 'FRESHNESS_FILTER',
    INTENT = 'INTENT',
    ESCALATION = 'ESCALATION',
    POST_PROCESS = 'POST_PROCESS',
    CRON = 'CRON',
    ROUTING = 'ROUTING',
    FOLLOW_UP = 'FOLLOW_UP',
}

export interface IPolicySet {
    additional_data: ICrumbAdditionalData;
    id: number;
    category: string;
    name: string;
    policy_type: PolicyType;
    suggested: boolean;
    weight?: number;
    created_date: string;
    updated_at: string;
}

export interface IPolicySetGroup {
    category: string;
    intents: IPolicySet[];
}

export const selectedPolicySetIdAtom = atom<number | undefined>(undefined);
